module.exports = __webpack_public_path__ + "media/Video 2.2be7fba4.mp4";